import { render, staticRenderFns } from "./VipCard.vue?vue&type=template&id=f3201282&"
import script from "./VipCard.vue?vue&type=script&lang=js&"
export * from "./VipCard.vue?vue&type=script&lang=js&"
import style0 from "./VipCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports